var $ = global.jQuery = global.$;

/**
 * Methods relating to adding widgets to the library and creating new widget instances
 * @exports lib/widgets
 * @author Simon Buerger
 */
var widgets = {
  registry: {},
  currentIndex: 0,
  lib: {},
  /**
   * Removes a widget instance from the registry
   *
   * @param {string} widgetId The id of the widget we want to remove
   * @instance
   */
  destroy: function(widgetId){
    delete this.registry[widgetId];
  },
  /**
   * Gets all descendants of the passed element.
   *
   * @instance
   * @param {object} $parent jQuery object representing the parent element
   * @param {string} fieldType the type of the field - matches against the widget name and any widgets extended of that widget's prototype.
   * @returns {array} An array containing the matching descendants
   */
  getDescendants: function($parent, fieldType) {
    var self = this,
      descendants = [],
      $descendantWidgets,
      index = 0;

    if (fieldType) {
      $descendantWidgets = $parent.find('[data-widget]');
    } else {
      $descendantWidgets = $parent.find('[data-widget]');
    }

    $descendantWidgets.each(function() {
      var id = $(this).attr('id');
      if (fieldType && self.registry[id] instanceof self.lib[fieldType]){
        descendants[index] = self.registry[id];
        index++;
      } else if (!fieldType){
        descendants[index] = self.registry[id];
        index++;
      }
    });

    return descendants;
  },
  /**
   * Creates a widget instance and adds it to the library. Used by {@link parser}
   *
   * @instance
   * @param {string|object} element ID of the widget OR a jQuery object representing the widget
   * @param {string} Type The class of the widget that needs to be created
   */
  addToRegistry: function(element, Type) {
    var $element = $(element);
    var id = $element.attr('id');
    if (!id) {
      id = 'widget-' + this.currentIndex;
    }

    if(!this.registry[id] && this.lib[Type]){
      $element.attr('id', id);
      this.registry[id] = new this.lib[Type](element);
      this.registry[id].__type = Type;
      this.registry[id].__id = id;
      this.currentIndex++;
    }

  },
  /**
   * Adds a class to the widget library
   *
   * @instance
   * @param {string} widgetName Name of the widget. This is the name that will appear in the library
   * @param {Class} Class The construtor function of the widget
   */
  create: function(widgetName, Class){
    this.lib[widgetName] = Class;
  },
  /**
   * Get a widget from the registry
   *
   * @instance
   * @param {string} id Id of the widget to fetch
   */
  getWidget: function(id){
    return this.registry[id] ? this.registry[id] : false;
  }
};

module.exports = widgets;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/lib/widgets.js
// module id = 5
// module chunks = 0 1